import {Button} from '_core'
import {toAbsoluteUrl} from '_metronic/helpers'
import {FC} from 'react'
import {Link, useNavigate} from 'react-router-dom'
type prop = {
  onHandleAuth: any
}
const InvalidLinkPage: FC<prop> = ({onHandleAuth}) => {
  const navigate = useNavigate()
  const handleNavigate = () => {
    onHandleAuth()
    navigate('/auth/login')
  }
  return (
    <div>
      <div className='fw-bolder fs-4 text-dark'>Link is Invalid</div>
      <p className='text-muted mt-3'>
        The link you are trying to access is no longer valid. Please log in to continue.
      </p>
      <Button
        id='btnLogin'
        onClick={handleNavigate}
        className='btn btn-primary mt-4 px-5'
        title={'Go to Login'}
      />
    </div>
  )
}

export default InvalidLinkPage
